
import { defineComponent, computed, watch, ref } from 'vue'
import ZpTable from '@/Base-UI/table/index'
import { useStore } from '@/store/index'
import { userPermission } from '@/hooks/use-permission'
export default defineComponent({
  name: 'page-content',
  props: {
    contentConfig: {
      type: Object,
      required: true
    },
    pageName: {
      type: String,
      required: true
    }
  },
  emits: ['newBtnClick', 'editBtnClick'],
  setup(props, { emit }) {
    const store = useStore()
    //存储上一个请求数据
    let lastQueryData = ref()
    /* 获取操作权限 */
    //创建权限
    const isCreate = userPermission(props.pageName, 'create')
    //编辑权限
    const isUpdate = userPermission(props.pageName, 'update')
    //删除权限
    const isDelete = userPermission(props.pageName, 'delete')
    //请求权限
    const isQuery = userPermission(props.pageName, 'query')

    /* 分页数据 */
    const pageInfo = ref({ currentPage: 1, size: 10 })
    watch(pageInfo, () => getPageData(lastQueryData))

    //发送请求
    const getPageData = (queryData: any = {}) => {
      //如果没有请求权限，则不会请求数据
      if (!isQuery) return
      lastQueryData = queryData
      store.dispatch('system/getPageListAction', {
        pageName: props.pageName,
        queryInfo: {
          offset: pageInfo.value.size * (pageInfo.value.currentPage - 1),
          size: pageInfo.value.size,
          ...lastQueryData //输入框数据
        }
      })
    }
    getPageData()
    //根据pageName调用getters
    const pageList = computed(() =>
      store.getters['system/pageListData'](props.pageName)
    )
    //根据pageName调用getters
    const dataCount = computed(() =>
      store.getters['system/pageListCount'](props.pageName)
    )
    /*获取其他动态插槽*/
    const otherPropSlots = props.contentConfig?.propList.filter((item: any) => {
      //除了状态,创建时间，更新时间，操作外，都是动态的插槽
      if (item.slotName === 'status') return false
      if (item.slotName === 'create') return false
      if (item.slotName === 'update') return false
      if (item.slotName === 'handle') return false
      return true
    })
    /* 新建事件 */
    const handleNewClick = () => {
      emit('newBtnClick')
    }
    /* 编辑事件 */
    const handleEditClick = (item: any) => {
      emit('editBtnClick', item)
    }
    /* 删除事件 */
    const handleDeleteClick = (item: any) => {
      store.dispatch('system/deletePageDataAction', {
        pageName: props.pageName,
        id: item.id
      })
    }
    return {
      pageList,
      dataCount,
      getPageData,
      pageInfo,
      otherPropSlots,
      isCreate,
      isUpdate,
      isDelete,
      handleDeleteClick,
      handleNewClick,
      handleEditClick
    }
  },
  components: {
    ZpTable
  }
})
